module.exports = __webpack_public_path__ + "assets/img/mask-talent-long.887ea052.png";